export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';
export const SET_EXTERNAL_OUTAGE = 'SET_EXTERNAL_OUTAGE';
export const SET_STORE_BEFORE_INIT = 'SET_STORE_BEFORE_INIT';
export const SET_APP_NAME = 'SET_APP_NAME';
export const SET_CALL_OBJECT_OUTAGE = 'SET_CALL_OBJECT_OUTAGE';
export const SET_API_OUTAGE = 'SET_API_OUTAGE';
export const initialState = {
  message: '',
  showError: false,
  ctaFunction: () => {},
  isExternalOutage: false,
  appName: 'in-meeting-experience-ui-components',
  isApiCallObjectOutage: false,
  isApiOutage: false
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_API_OUTAGE:
      return Object.assign({}, state, {
        isApiOutage: action.payload
      });
    case SET_CALL_OBJECT_OUTAGE:
      return Object.assign({}, state, {
        isApiCallObjectOutage: action.payload
      });
    case SET_ERROR:
      return Object.assign({}, state, action.payload);
    case RESET_ERROR:
      return Object.assign({}, initialState);
    case SET_EXTERNAL_OUTAGE:
      {
        const {
          isExternalOutage,
          appName
        } = action.payload;
        return Object.assign({}, state, {
          isExternalOutage
        }, appName && {
          appName
        });
      }
    case SET_STORE_BEFORE_INIT:
      return Object.assign({}, state, action.payload);
    case SET_APP_NAME:
      return Object.assign({}, state, {
        appName: action.payload
      });
    default:
      return state;
  }
};